import React, { useEffect } from 'react'
import { useFriendStore } from '@/stores/useFriendStore'
import { useFriendActions } from '@/hooks/useFriendActions'
import { FriendInfo } from '@/api/types'

export default function BlockedUsersList(): React.JSX.Element {
  const {
    blockedList,
    blockedListLoading,
    blockedListError,
    getBlockedList,
    removeFromBlockedList,
  } = useFriendStore()
  const friendActions = useFriendActions()

  useEffect(() => {
    getBlockedList()
  }, [getBlockedList])

  // 处理取消拉黑
  const handleUnblock = async (user: FriendInfo) => {
    const confirmed = confirm(`确定要取消拉黑用户 ${user.alias || user.nickname} 吗？`)
    if (!confirmed) return

    const success = await friendActions.unblockFriend({ friend_id: user.id })
    if (success) {
      // 从拉黑列表中移除
      removeFromBlockedList(user.id)
      // 重新添加到好友列表（如果需要的话）
      // addFriendToList(user)
    }
  }

  if (blockedListLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">加载中...</div>
      </div>
    )
  }

  if (blockedListError) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="text-red-600 text-sm">{blockedListError}</div>
          <button
            onClick={() => getBlockedList()}
            className="mt-2 text-red-600 hover:text-red-700 text-sm underline"
          >
            重试
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">拉黑用户列表</h2>
        <p className="text-sm text-gray-500">
          管理您拉黑的用户，可以选择取消拉黑
        </p>
      </div>

      {blockedList.length === 0 ? (
        <div className="text-center py-12">
          <div className="text-gray-400 mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
          <p className="text-gray-500 text-sm">暂无拉黑用户</p>
        </div>
      ) : (
        <div className="space-y-4">
          {blockedList.map((user) => (
            <div
              key={user.id}
              className="flex items-center justify-between p-4 bg-white border border-gray-200 rounded-lg hover:shadow-sm transition-shadow"
            >
              <div className="flex items-center space-x-3">
                <img
                  src={user.avatar}
                  alt={user.alias || user.nickname}
                  className="w-10 h-10 rounded-full"
                />
                <div>
                  <div className="font-medium text-gray-900">
                    {user.alias || user.nickname}
                  </div>
                  <div className="text-sm text-gray-500">
                    ID: {user.handle}
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                {user.remark && (
                  <div className="text-sm text-gray-500">
                    备注: {user.remark}
                  </div>
                )}
                <button
                  onClick={() => handleUnblock(user)}
                  disabled={friendActions.isLoading}
                  className="px-3 py-1.5 text-sm text-blue-600 hover:text-blue-700 border border-blue-300 hover:border-blue-400 rounded transition-colors disabled:opacity-50"
                >
                  {friendActions.isLoading ? '处理中...' : '取消拉黑'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 刷新按钮 */}
      <div className="mt-6 text-center">
        <button
          onClick={() => getBlockedList()}
          disabled={blockedListLoading}
          className="px-4 py-2 text-sm text-gray-600 hover:text-gray-700 border border-gray-300 hover:border-gray-400 rounded transition-colors disabled:opacity-50"
        >
          {blockedListLoading ? '刷新中...' : '刷新列表'}
        </button>
      </div>

      {/* 错误提示 */}
      {friendActions.error && (
        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{friendActions.error}</p>
        </div>
      )}
    </div>
  )
}
